import { useNavigate, useLocation } from "react-router-dom";
import "../../../styles/Auth/settings.css";
const SettingsHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="settings-widgets">
            <button
                className={`general-settings ${location.pathname === "/settings" ? "active" : ""}`}
                onClick={() => navigate("/settings")}
            >
                General Settings
            </button>

            <button
                className={`profile-settings ${location.pathname === "/settings/profile" ? "active" : ""}`}
                onClick={() => navigate("/settings/profile")}
            >
                Profile
            </button>

            {/* <button
                className={`tax-settings ${location.pathname === "/settings/tax" ? "active" : ""}`}
                onClick={() => navigate("/settings/tax")}
            >
                Tax Settings
            </button> */}
        </div>
    );
};

export default SettingsHeader;
